import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initSentry } from './app/shared/services/logger.service'

if (environment.sentry.allow) {
  initSentry();
}

if (!environment.useMocks) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
